class CustomSortDropdown {
  constructor() {
    this.init();
  }

  init() {
    const sortButton = document.querySelector('.custom-sort-button');
    const sortPanel = document.querySelector('.custom-sort-panel');
    const sortOptions = document.querySelectorAll('.custom-sort-option__input');
    const sortForm = document.getElementById('FacetSortForm');

    if (!sortButton || !sortPanel || !sortForm) return;

    // Toggle dropdown on button click
    sortButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isExpanded = sortButton.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.closeDropdown(sortButton, sortPanel);
      } else {
        this.openDropdown(sortButton, sortPanel);
      }
    });

    // Handle option selection
    sortOptions.forEach(option => {
      option.addEventListener('change', (e) => {
        // Update selected state
        document.querySelectorAll('.custom-sort-option').forEach(opt => {
          opt.classList.remove('custom-sort-option--selected');
        });
        option.closest('.custom-sort-option').classList.add('custom-sort-option--selected');

        // Submit the form to apply sorting
        const formData = new FormData(sortForm);
        const searchParams = new URLSearchParams(formData);
        const url = new URL(window.location.href);
        
        // Update sort_by parameter
        url.searchParams.set('sort_by', option.value);
        
        // Navigate to new URL
        window.location.href = url.toString();
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!sortButton.contains(e.target) && !sortPanel.contains(e.target)) {
        this.closeDropdown(sortButton, sortPanel);
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDropdown(sortButton, sortPanel);
        sortButton.focus();
      }
    });
  }

  openDropdown(button, panel) {
    button.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
  }

  closeDropdown(button, panel) {
    button.setAttribute('aria-expanded', 'false');
    panel.setAttribute('hidden', '');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomSortDropdown();
  });
} else {
  new CustomSortDropdown();
}
